import React from 'react';
import cx from 'classnames';

import { SingleBoxDescriptive } from '@commons/single-box-descriptive/SingleBoxDescriptive';
import * as styles from './paragraphs-with-boxes.module.scss';

export const ParagraphsWithBoxes = ({
  firstParagraph,
  secondParagraph,
  thirdParagraph = '',
  methods,
  classNames: { paragraph, boxesContainer, singleBoxDescription } = {},
}) => {
  return (
    <>
      <p>{firstParagraph}</p>
      <p className={cx(styles.paragraph, paragraph)}>{secondParagraph}</p>
      {thirdParagraph !== '' && <p className={cx(styles.thirdParagraph, paragraph)}>{thirdParagraph}</p>}
      <div className={cx(styles.boxesContainer, boxesContainer)}>
        {methods.map((box, i) => (
          <SingleBoxDescriptive key={i} {...box} classNames={{ description: singleBoxDescription }} />
        ))}
      </div>
    </>
  );
};
